interface ToggleProps {
	checked: boolean;
	onChange: (checked: boolean) => void;
	leftLabel: string;
	rightLabel: string;
}

export default function Toggle({ checked, onChange, leftLabel, rightLabel }: ToggleProps) {
	return (
		<div className="fixed bottom-[calc(30px+env(safe-area-inset-bottom))] left-1/2 -translate-x-1/2 z-[1000]">
			<label className="relative inline-block cursor-pointer select-none">
				<input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} className="hidden" />
				<span className="flex gap-0 bg-gradient-to-br from-[#374151] to-[#1f2937] rounded-xl p-1 shadow-[0_8px_32px_rgba(0,0,0,0.4),inset_0_1px_2px_rgba(255,255,255,0.1)] relative backdrop-blur-md border border-white/10">
					{/* Slider animé */}
					<span
						className={`absolute top-1 h-[calc(100%-8px)] rounded-lg bg-gradient-to-br from-blue-400 to-blue-600 shadow-[0_4px_12px_rgba(59,130,246,0.5),inset_0_1px_1px_rgba(255,255,255,0.3)] transition-all duration-300 ease-out ${
							!checked ? "left-1 w-[calc(50%-4px)]" : "left-[calc(50%+1px)] w-[calc(50%-4px)]"
						}`}
					/>

					{/* Labels statiques */}
					<span
						className={`text-[13px] font-semibold py-2.5 px-5 rounded-lg z-[2] transition-colors duration-300 ${!checked ? "text-white" : "text-gray-300"}`}
					>
						{leftLabel}
					</span>
					<span
						className={`text-[13px] font-semibold py-2.5 px-5 rounded-lg z-[2] transition-colors duration-300 ${checked ? "text-white" : "text-gray-300"}`}
					>
						{rightLabel}
					</span>
				</span>
			</label>
		</div>
	);
}
